module.exports = __webpack_public_path__ + "static/media/Bookndrive_logo_white.42670678.png";